module.exports = __webpack_public_path__ + "191d236634416cef463c33bf838d1147.svg";